import { render, staticRenderFns } from "./SemiCirclePie.vue?vue&type=template&id=10a5a193&"
import script from "./SemiCirclePie.vue?vue&type=script&lang=js&"
export * from "./SemiCirclePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports